import React from "react";
import Navbar from "../components/Navbar";
import "../styles/global.css";
import Blogs from "../components/Blogs";
import Career from "../components/Career";
import Footer from "../components/Footer";
import { Helmet } from "react-helmet-async";

const CareersPage = () => {
  return (
    <>
      <Helmet>
        <title>Career | TimeWatch Infocom</title>
        <meta
          name="description"
          content="Explore exciting career opportunities at TimeWatch Infocom, a leading provider of biometric solutions, access control systems, and smart security technologies in Delhi. Join our dynamic team of experts working on cutting-edge security innovations, including entrance automation and parking management solutions. We are committed to fostering professional growth, offering competitive benefits, and creating an inclusive work environment. If you're passionate about technology, innovation, and delivering impactful solutions, apply now and advance your career with a trusted name in the security industry."
        />
        <link rel="canonical" href="https://www.timewatchindia.com/careers" />
      </Helmet>
      <header className="navbar">
        <Navbar />
      </header>

      <div className="content-container">
        <section className="careers" style={{ marginTop: "5rem" }}>
          <Career />
        </section>
      </div>

      <footer className="footer">
        <Footer />
      </footer>
    </>
  );
};

export default CareersPage;
